import React from 'react';
import Map from '../../components/Map'
import Zoomable from '../../components/Zoomable'

import suaideia from '../../assets/portfolio/suaideia.png'
import marcheti from '../../assets/portfolio/marcheti.png'
import map from '../../assets/portfolio/mapa02.png'

import './style.css'

function Portifolio() {
  return (
    <div id='portifolio'>
      <section className='Portifolio'>
        <h1>Portfolio</h1>
        
        <div id='marcheti'>
          <img src={marcheti} />
          <div>
            <p>Duarte Marcheti Art Website page creation</p>
            <a href='https://duart-marchet-art.herokuapp.com/' target='_blank'><button>Check It Out</button></a>
          </div>
        </div>
        <div id='suaideia'>
          <img src={suaideia} />
          <div>
            <p>SMC Assessoria de Negócios Website page creation</p>
            <a href='https://asuaideia.com.br/' target='_blank'><button>Check It Out</button></a>
          </div>
        </div>
        <div id='map'>
          <img src={map} />
          <Map />
          <div>
            <p className='title'>Choropleph Map</p>
            <p>A choropleph map representation developed with D3.js JavaScript lib.</p>
            <a href='https://nostalgic-sammet-772965.netlify.app/' target='_blank'><button>Check It Out</button></a>
          </div>
        </div>
        <div id='zoomable'>
          <Zoomable />
          <div>
            <h2>Zoomable Sumburst</h2>
            <p>

              This is my React Hooks implementation of the Mike Bostock data vizualization.
              "This radial space-filling visualization created by John Stasko shows the cumulative values of subtrees.
              It is commonly used to visualize software packages (the size of source code within nested packages)
              and file systems (the size of files within nested folders)." - Mike Bostock.

            </p>
            <a href='https://observablehq.com/@d3/zoomable-sunburst'>observablehq.com/@d3/zoomable-sunburst</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Portifolio;